import React from 'react';
import './mfa.scss';
import { Switch } from 'antd';
import { FormLayoutRow } from '../../form-layout-row/form-layout-row';
import { StatusBadge } from '../../badges/status-badge';
export var AccountMfaRememberBrowserControl = function AccountMfaRememberBrowserControl(props) {
  var value = props.value,
    onChange = props.onChange,
    readonly = props.readonly;
  var statusName = value ? 'ENABLED' : 'DISABLED';
  return /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "Remember Browser",
    value: readonly ? /*#__PURE__*/React.createElement(StatusBadge, {
      status: statusName,
      expanded: true
    }) : /*#__PURE__*/React.createElement(Switch, {
      checked: value,
      size: "small",
      onChange: onChange
    }),
    info: {
      inline: true,
      tooltipClassName: 'mfa-remember-browser-tooltip',
      title: /*#__PURE__*/React.createElement(React.Fragment, null, "When enabled, users will be allowed to check a box to skip MFA for 30 days for their current browser.")
    }
  });
};